import { Users } from "lucide-react";
import { useUsersByPermission } from "@/features/admin/hooks/useUser";

interface ApproversInfoProps {
  permission: string;
  label?: string;
}

/**
 * Displays a compact list of active users who hold the given permission.
 * Shown on approval-request pages so submitters know who to contact.
 */
export const ApproversInfo = ({ permission, label = "Approvers" }: ApproversInfoProps) => {
  const { data: approvers, isLoading } = useUsersByPermission(permission);

  if (isLoading) {
    return (
      <div className="flex items-center gap-1.5 text-xs text-muted-foreground">
        <Users className="h-3.5 w-3.5 shrink-0" />
        <span>Loading approvers…</span>
      </div>
    );
  }

  if (!approvers || approvers.length === 0) {
    return (
      <div className="flex items-center gap-1.5 text-xs text-muted-foreground">
        <Users className="h-3.5 w-3.5 shrink-0" />
        <span>No approvers assigned</span>
      </div>
    );
  }

  const names = approvers
    .map((u) => `${u.firstName} ${u.otherNames}`.trim())
    .join(", ");

  return (
    <div className="flex items-start gap-1.5 text-xs text-muted-foreground">
      <Users className="mt-0.5 h-3.5 w-3.5 shrink-0" />
      <span>
        <span className="font-medium text-foreground">{label}:</span> {names}
      </span>
    </div>
  );
};
